module.exports = __webpack_public_path__ + "img/tas_yes.010fc37e.png";